import { Locale } from 'date-fns';
import {
  cs,
  da,
  de,
  enGB,
  enUS,
  es,
  frCA,
  fr,
  it,
  ja,
  ko,
  nl,
  nb,
  pl,
  ptBR,
  ru,
  sv,
  zhCN,
  zhTW,
} from 'date-fns/locale';

export const DAYS_OF_THE_WEEK_IN_ENGLISH = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const;

export const INTERVAL_UNITS = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
} as const;

export const DEFAULT_INTERVAL_UNITS = Object.values(INTERVAL_UNITS);

export const DATE_FNS_LOCALE: { [key: string]: Locale } = {
  cs,
  da,
  de,
  'en-GB': enGB,
  en: enUS,
  es,
  'fr-CA': frCA,
  fr,
  it,
  ja,
  ko,
  nl,
  no: nb,
  pl,
  'pt-BR': ptBR,
  ru,
  sv,
  'zh-Hans': zhCN,
  'zh-Hant-HK': zhTW,
  'zh-Hant': zhTW,
  zhh: zhTW,
};

export const DEFAULT_TIME = '8:00 AM';
